import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

export async function getDashboardReport(web_id, filter_val, from = "", to = "") {
  try {
    const formData = new FormData();
    formData.append("web_id", web_id);
    formData.append("filter_val", filter_val);
    if (from) formData.append("from", from);
    if (to) formData.append("to", to);

    const response = await axios.post(`${apiBaseUrl}ana_report/get_ana_report`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      message: "Failed to fetch analytics report",
    };
  }
}

export async function getWebsiteById(web_id, user_id) {
  try {
    const formData = new FormData();
    formData.append("web_id", web_id);
    formData.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}website/get_web_by_id`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      message: "Failed to fetch website details",
    };
  }
}

export async function getWebsiteList(user_id) {
  try {
    const formData = new FormData();
    formData.append("page_no", "none");
    formData.append("web_user", user_id);

    const response = await axios.post(`${apiBaseUrl}website/get_web_list`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      message: "Failed to fetch website list",
    };
  }
}

export async function getConversations(user_id, page_no = 0) {
  try {
    const formData = new FormData();
    formData.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}chat/get_convs/${page_no}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      message: "Failed to fetch conversations",
    };
  }
}

export async function getMessages(conv_id, user_id, page_no = 0) {
  try {
    const formData = new FormData();
    formData.append("conv_id", conv_id);
    formData.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}chat/get_msgs/${page_no}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      message: "Failed to fetch chat messages",
    };
  }
}

export async function createConversation(user_id, web_id) {
  try {
    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("web_id", web_id);

    const response = await axios.post(`${apiBaseUrl}chat/create_conv_now`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      message: "Failed to create new conversation",
    };
  }
}

export async function getLastConversation(user_id, web_id) {
  try {
    const formData = new FormData();
    formData.append("web_id", web_id);
    formData.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}chat/get_last_conv`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      message: "Failed to fetch last conversation",
    };
  }
}

export async function sendMessage(msg_txt, conv_id, user_id) {
  try {
    const formData = new FormData();
    formData.append("msg_txt", msg_txt);
    formData.append("msg_conv", conv_id);
    formData.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}chat/send_msg`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      message: "Failed to send message",
    };
  }
}

export async function getAiMessage(msg_id, analytics_data = {}) {
  try {
    const formData = new FormData();
    formData.append("msg_id", msg_id);
    formData.append("analytics_data", JSON.stringify(analytics_data));

    const response = await axios.post(`${apiBaseUrl}chat/get_ai_msg`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      message: "Failed to get AI response",
    };
  }
}
